/**
 * Display metadata for the Workday-sourced qualification flags stored on
 * `public.user_qualifications`. Column names mirror
 * `supabase/functions/workday/qualifications.ts` — keep the two in sync when a
 * new Workday code is added.
 */
export interface QualificationField {
  /** Column on `public.user_qualifications`. */
  column: string;
  /** Workday code as sent in the roster payload. */
  code: string;
}

export const QUALIFICATION_FIELDS: QualificationField[] = [
  { column: "atos", code: "ATOS" },
  { column: "aum", code: "AUM" },
  { column: "aum_cw", code: "AUM-CW" },
  { column: "avos", code: "AVOS" },
  { column: "ci_ls", code: "CI_LS" },
  { column: "ci_rs", code: "CI_RS" },
  { column: "cta", code: "CTA" },
  { column: "cvsa_epti", code: "CVSA_EPTI" },
  { column: "dev_ls", code: "DEV_LS" },
  { column: "dev_rs", code: "DEV_RS" },
  { column: "dis", code: "DIS" },
  { column: "dto", code: "DTO" },
  { column: "do_not_remove_cover_shift", code: "DoNotRemove_CoverShift" },
  { column: "fast", code: "FAST" },
  { column: "map", code: "MAP" },
  { column: "mcs", code: "MCS" },
  { column: "mrt", code: "MRT" },
  { column: "msha", code: "MSHA" },
  { column: "ras", code: "RAS" },
  { column: "rob", code: "ROB" },
  { column: "rp", code: "RP" },
  { column: "to_qual", code: "TO" },
];

export const QUALIFICATION_SELECT = [
  "email",
  "is_active",
  "last_synced_at",
  ...QUALIFICATION_FIELDS.map((f) => f.column),
].join(", ");

export type UserQualificationRow = Record<string, unknown> & {
  email: string;
  is_active?: boolean | null;
  last_synced_at?: string | null;
};

/** Codes the person currently holds, in display order. */
export function heldQualifications(row: UserQualificationRow | null): string[] {
  if (!row) return [];
  return QUALIFICATION_FIELDS.filter((f) => row[f.column] === true).map((f) => f.code);
}
